module.exports = __webpack_public_path__ + "static/img/1.7b82addd.jpg";